import ar from './ar.json'
import en from './en.json'

export default {
    "ar":ar,
    "en":en
}